import { render } from "./createTicketNewForm.vue?vue&type=template&id=63590adc&scoped=true"
import script from "./createTicketNewForm.vue?vue&type=script&lang=js"
export * from "./createTicketNewForm.vue?vue&type=script&lang=js"

import "./createTicketNewForm.vue?vue&type=style&index=0&id=63590adc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63590adc"]])

export default __exports__